var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { role: "document", "aria-labelledby": "user-guide-heading" } },
    [
      _c(
        "b-container",
        { staticClass: "col-9 mt-5", staticStyle: { padding: "0px 9% 0 9%" } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "to-lang",
                  rawName: "v-to-lang.children",
                  modifiers: { children: true },
                },
              ],
            },
            [
              _c(
                "h1",
                {
                  staticClass: "ug-heading",
                  attrs: { id: "user-guide-heading", tabindex: "-1" },
                },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.$t("main-heading")) },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead" }, [
                _c("b", [
                  _c("span", {
                    staticStyle: {
                      "font-size": "14.0pt",
                      "line-height": "115%",
                      color: "#4A86E8",
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [_vm._v("   ")]
                        ),
                        _vm._v(_vm._s(_vm.$t("one")) + "."),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-1")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-1-para-1")) },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-1-para-point-1")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-1-para-point-2")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-1-para-point-3")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-1-para-2")) },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-1-para-2-point-1")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-1-para-2-point-2")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "d-flex flex-column",
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image001.png",
                        alt: _vm.$t("para-1-img-alt"),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("para-1-img-q-tip")))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("two")) +
                            "."
                        ),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-2")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-2-para-1")) },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-2-para-1-point-1")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-2-para-1-point-2")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-2-para-1-point-3")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-2-para-1-point-4")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead ml-5" }, [
                _c("span", [
                  _c("span", { staticClass: "bullet" }, [
                    _vm._v("\n                        ●"),
                    _c("span", {
                      staticStyle: { font: '7.0pt "Times New Roman"' },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("sub-heading-2-para-1-point-5")),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-2-para-2")) },
              }),
              _vm._v(" "),
              _c("p", { attrs: { align: "center" } }, [
                _c("span", [
                  _c("img", {
                    staticClass: "mt-5",
                    staticStyle: { width: "60%" },
                    attrs: {
                      src:
                        _vm.basePath +
                        "/images/user-guide-" +
                        _vm.getCurrentLanguage +
                        "/image003.png",
                      alt: _vm.$t("para-2-img-alt"),
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("three")) +
                            "."
                        ),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-3")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-3-para")) },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image005.png",
                        alt: _vm.$t("para-3-img-alt"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("four")) +
                            "."
                        ),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-4")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-4-para-1")) },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image007.png",
                        alt: _vm.$t("para-4-img-alt"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("para-4-footer-para-1")) },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image009.png",
                        alt: _vm.$t("para-4-img-alt-2"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [_vm._v("  ")]
                        ),
                        _vm._v(_vm._s(_vm.$t("five")) + "."),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-5")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-5-para-1")) },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image011.png",
                        alt: _vm.$t("sub-heading-5-img-alt"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("sub-heading-5-footer-para-1")),
                },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image013.png",
                        alt: _vm.$t("sub-heading-5-img-alt-2"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("sub-heading-5-footer-para-2")),
                },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image015.png",
                        alt: _vm.$t("sub-heading-5-img-alt-3"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image017.png",
                        alt: _vm.$t("sub-heading-5-img-alt-4"),
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("six")) +
                            "."
                        ),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-6")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-6-para-1")) },
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image019.png",
                      },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-indent": ".5in",
                    "line-height": "115%",
                  },
                },
                [_c("span")]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "sub-heading" }, [
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("seven")) +
                            "."
                        ),
                        _c(
                          "span",
                          { staticStyle: { font: '7.0pt "Times New Roman"' } },
                          [
                            _vm._v(
                              "\n                                       \n                            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("b", [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "14.0pt",
                        "line-height": "115%",
                        color: "#4A86E8",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("sub-heading-7")) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "text-justify lead",
                domProps: { innerHTML: _vm._s(_vm.$t("sub-heading-7-para-1")) },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-justify lead" }, [
                _c("b", [_c("span")]),
              ]),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    "margin-top": "0in",
                    "text-align": "center",
                    "line-height": "115%",
                  },
                  attrs: { align: "center" },
                },
                [
                  _c("span", [
                    _c("img", {
                      staticClass: "mt-5",
                      staticStyle: { width: "60%" },
                      attrs: {
                        src:
                          _vm.basePath +
                          "/images/user-guide-" +
                          _vm.getCurrentLanguage +
                          "/image021.png",
                        alt: _vm.$t("sub-heading-7-img-alt"),
                      },
                    }),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }